import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const TicketsQueueSelect = ({
	userQueues,
	userQueueOptions = [],
	selectedQueueIds = [],
	selectedQueueOptionIds = [],
	onChange,
}) => {
	const handleChange = e => {
		const values = e.target.value;
		const qIds = values.filter(v => typeof v === 'number');
		const qoIds = values.filter(v => typeof v === 'string' && v.startsWith('opt-')).map(v => parseInt(v.split('-')[1]));
		onChange(qIds, qoIds);
	};

	const combinedSelected = [
		...(selectedQueueIds || []),
		...(selectedQueueOptionIds ? selectedQueueOptionIds.map(id => `opt-${id}`) : [])
	];

	return (
		<div style={{ width: 120, marginTop: -4 }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={combinedSelected}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
				>
					{userQueues?.length > 0 &&
						userQueues.map(queue => (
							[
								<MenuItem dense key={queue.id} value={queue.id}>
									<Checkbox
										style={{
											color: queue.color,
										}}
										size="small"
										color="primary"
										checked={selectedQueueIds.indexOf(queue.id) > -1}
									/>
									<ListItemText primary={queue.name} />
								</MenuItem>,
								...(userQueueOptions || []).filter(opt => opt.queueId === queue.id).map(opt => (
									<MenuItem dense key={`opt-${opt.id}`} value={`opt-${opt.id}`} style={{ paddingLeft: 30 }}>
										<Checkbox
											style={{
												color: queue.color,
											}}
											size="small"
											color="primary"
											checked={selectedQueueOptionIds.indexOf(opt.id) > -1}
										/>
										<ListItemText primary={`↳ ${opt.title}`} />
									</MenuItem>
								))
							]
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsQueueSelect;
